import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports-list',
  templateUrl: './reports-list.component.html',
  styleUrls: ['./reports-list.component.css']
})
export class ReportsListComponent implements OnInit {

  permissions = [];
  type: string;
  constructor() {

    this.permissions = [{ name: 'Orders', actions: [{ name: 'Order Detail', enabled: false }] },
    { name: 'Products', actions: [{ name: 'Demand by SKU', enabled: false }, { name: 'Product Sales', enabled: false }, { name: 'Returned Products list', enabled: false }] },
    { name: 'Inventory Reports', actions: [{ name: 'Low Stock Report', enabled: true }, { name: 'Out Of Stock Report', enabled: false }, { name: 'Stock Status Report', enabled: false }, { name: 'Inventory Adjustments', enabled: false }] },
    { name: 'Shipments', actions: [{ name: 'Shipments', enabled: true }, { name: 'Shipment Cost', enabled: false }, { name: 'Shipped products', enabled: false }] },
    { name: 'Accounting', actions: [{ name: 'Account Snapshot', enabled: true }] },
    { name: 'Other reports', actions: [{ name: 'Customer details', enabled: true }, { name: 'Order all details', enabled: false }, { name: 'Products', enabled: false }] },
    { name: 'Warehouses', actions: [{ name: 'Warehouse', enabled: true }, { name: 'Report', enabled: false }] }

    ];
  }

  ngOnInit(): void {
  }
  sliceUPto(num) {
    if (num) {
      if (num % 2 == 0) {
        return num / 2;
      } else {
        return (num + 1) / 2;
      }
    } else {
      return 0;
    }
  }
}
